import { render, staticRenderFns } from "./Anttedance.vue?vue&type=template&id=446c3d75"
import script from "./Anttedance.vue?vue&type=script&lang=js"
export * from "./Anttedance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports